var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotConnectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF1FD",
    d: "M80 40c0 22.091-17.909 40-40 40S0 62.091 0 40 17.909 0 40 0s40 17.909 40 40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD2FA",
    d: "M50.666 69.058c0 .858-4.775 1.554-10.665 1.554-5.89 0-10.665-.696-10.665-1.554 0-.859 4.775-1.555 10.665-1.555 5.89 0 10.665.696 10.665 1.555Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7D9F8",
    d: "m32.413 24.061 21.429 14.572-2.6 3.824-21.43-14.572 2.601-3.824Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    fillRule: "evenodd",
    d: "m53.714 33.882.117.084a2.777 2.777 0 0 1 .695 3.653l-.077.12-4.684 6.888c-4.023 5.917-12.082 7.453-18 3.429-5.917-4.024-7.452-12.083-3.428-18l4.684-6.888.083-.116a2.777 2.777 0 0 1 3.654-.696l.12.077 16.836 11.45Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m30.578 28.406-1.476 2.17c-3.736 5.495-2.31 12.978 3.184 16.715C37.78 51.026 45.264 49.6 49 44.107l1.476-2.17-19.898-13.531Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7D9F8",
    fillRule: "evenodd",
    d: "M31.116 27.653 50.98 41.16l1.56-2.294L32.676 25.36l-1.56 2.294Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.357 23.199a1.85 1.85 0 0 0-2.571.49l-.607.893 19.898 13.53.607-.893a1.851 1.851 0 0 0-.49-2.571l-16.837-11.45Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7D9F8",
    d: "M43.887 17.279a2.329 2.329 0 1 1 3.852 2.619l-5.106 7.51-3.852-2.62 5.106-7.51Zm7.986 5.431a2.329 2.329 0 1 1 3.852 2.619l-5.106 7.509-3.852-2.62 5.106-7.509Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "m42.633 27.407-3.852-2.62 5.106-7.508a2.329 2.329 0 1 1 3.852 2.619l-5.106 7.51Zm7.986 5.431-3.852-2.62 5.106-7.509a2.329 2.329 0 1 1 3.852 2.62l-5.106 7.509ZM34.41 48.587a.461.461 0 0 1-.15.895.428.428 0 0 0-.046.024 1.81 1.81 0 0 0-.359.307c-.324.34-.778.955-1.341 2.005-.341.723-.745 1.718-1.593 2.662-.861.959-2.159 1.847-4.268 2.459-1.323.383-3.864.848-5.827.658-1.061-.104-1.896-.457-2.698-.827-.808-.372-1.577-.756-2.58-1.002a.463.463 0 0 1 .22-.899c1.108.272 1.967.701 2.747 1.06.786.363 1.502.66 2.4.747 1.8.175 4.216-.259 5.48-.626 1.968-.57 3.107-1.376 3.837-2.188.74-.824 1.084-1.676 1.448-2.446l.005-.01.005-.01c.59-1.101 1.092-1.797 1.495-2.22.2-.212.387-.365.556-.466.152-.09.36-.18.579-.146l.09.023Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M30.216 45.76a.461.461 0 0 1-.122.911 1.21 1.21 0 0 0-.307.233c-.267.263-.643.76-1.093 1.643-.277.635-.648 1.472-1.422 2.246-.787.788-1.958 1.48-3.794 1.895-.7.158-2.795.415-4.518-.756l-.003-.002c-1.145-.791-2.637-1.49-4.239-1.767a.463.463 0 0 1 .158-.912c1.755.302 3.37 1.063 4.604 1.915l.267.165c1.354.765 2.95.584 3.527.454 1.696-.383 2.7-1.003 3.344-1.646.647-.648.961-1.35 1.236-1.981l.006-.013.006-.013c.478-.938.908-1.53 1.271-1.888.181-.179.356-.309.522-.392.154-.076.354-.138.557-.093Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7D9F8",
    d: "M46.974 19.378a1.404 1.404 0 0 0-2.322-1.579l-4.586 6.744 2.322 1.579 4.586-6.744Zm7.986 5.43a1.404 1.404 0 0 0-2.321-1.578l-4.587 6.744 2.322 1.579 4.586-6.745Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedIcon);
export default __webpack_public_path__ + "static/media/not_connected_icon.0cd95ca19ed14f336c5cadeaabb6736e.svg";
export { ForwardRef as ReactComponent };